module.exports = __webpack_public_path__ + "media/images/flags/64/Guinea-4dd780d20b0f00788429abfe0dc574d5.png";